import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EMPTY_OBJECT, RESPONSIVE_SIZE } from '../../constants';
import intercom from '../../lib/intercom';
import { getDisplayName } from '../../lib/react';
import { showLogin } from '../../actions/user';
import { Brandmark } from '../Icons';
import Link from '../Link';
import Style from '../Style';
import { H5, L4, P1, P2 } from '../Typography';
import config from '../../config';

class FooterComp extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number.isRequired,
    showLogin: PropTypes.func,
    empty: PropTypes.bool,
    collapse: PropTypes.bool,
    marketing: PropTypes.bool,
  };
  static defaultProps = {
    empty: false,
    collapse: false,
    marketing: false,
  };

  render() {
    const { responsive, showLogin, empty, collapse, ...otherProps } = this.props;

    let containerStyle = {
      backgroundColor: Style.Colors.black,
      color: Style.Colors.white,
      position: 'relative',
    };

    let brandmarkStyle = {
      display: 'block',
      fill: Style.Colors.white,
      maxWidth: '6.6rem',
      width: '100vw',
    };
    let navBrandmarkStyle = {
      ...brandmarkStyle,
    };
    let centerBrandmarkStyle = {
      ...brandmarkStyle,
    };

    let labelStyle = { opacity: 0.5 };

    let bottomRowStyle = {
      display: 'flex',
      justifyContent: 'space-between',
    };

    let P = P2;
    let containerPadding = '6.3rem 3.5rem 3.5rem';
    let bottomCellPaddingTop = '1rem';
    let bottomRowPaddingTop = '4rem';
    let bottomRowFlexDirection = 'column';

    let navBrandmarkOpacity = 1;
    let centerBrandmarkOpacity = 0;

    if (responsive >= RESPONSIVE_SIZE.PHONE) {
      P = P1;
      bottomCellPaddingTop = '2rem';
      containerPadding = '6.3rem 3.5rem 5rem';
    }
    if (responsive >= RESPONSIVE_SIZE.TABLET_PORTRAIT) {
      bottomCellPaddingTop = '3rem';
      bottomRowPaddingTop = '10rem';
    }
    if (responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      containerPadding = '9rem 12rem 9rem';
      navBrandmarkOpacity = 0;
      centerBrandmarkOpacity = 1;
      bottomRowFlexDirection = 'row';
    }

    return (
      <div style={{ ...containerStyle, padding: containerPadding }}>
        <div>
          <Brandmark style={{ ...navBrandmarkStyle, opacity: navBrandmarkOpacity }} />
          <div
            style={{
              pointerEvents: empty ? 'none' : undefined,
              opacity: empty ? 0 : 1,
              display: collapse ? 'none' : 'initial',
            }}
          >
            <L4
              style={{
                ...labelStyle,
                display: 'block',
                padding: '8rem 0 2rem',
              }}
            >
              STORYTAPE NAVIGATION
            </L4>
            <NavLink to="/">Home</NavLink>
            <NavLink to="/how-it-works">How it Works</NavLink>
            <NavLink to="/pricing">Pricing Plans</NavLink>
            <NavLink to="/browse">Browse Scenes</NavLink>
            <NavLink to="/legal">Privacy &amp; Terms</NavLink>
            <NavLink onClick={(e) => intercom.startConversation()}>Get Support</NavLink>
            <NavLink onClick={this.props.showLogin}>Sign In</NavLink>
          </div>
        </div>

        <div
          style={{
            ...bottomRowStyle,
            paddingTop: bottomRowPaddingTop,
            flexDirection: bottomRowFlexDirection,
          }}
        >
          <div style={{ paddingTop: bottomCellPaddingTop }}>
            <L4 style={{ ...labelStyle }}>QUESTIONS? NEED HELP?</L4>
            {!this.props.marketing && (
              <P>
                <Link onClick={(e) => intercom.startConversation()}>Contact our Support Team</Link>
              </P>
            )}
            {this.props.marketing && (
              <P>
                <Link onClick={(e) => intercom.startConversation()}>Contact Support</Link> &mdash;
                <Link to="/legal"> Terms of Service</Link>
              </P>
            )}
          </div>
          <div style={{ paddingTop: bottomCellPaddingTop }}>
            <L4 style={{ ...labelStyle }}>COPYRIGHT {new Date().getFullYear()}</L4>
            <P>
              <Link to="https://www.prochurchtools.com">Pro Church Tools, Inc.</Link>
            </P>
          </div>
        </div>

        <div
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Brandmark style={{ ...centerBrandmarkStyle, opacity: centerBrandmarkOpacity }} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { responsive: state.runtime.responsive };
}

function mapDispatchToProps(dispatch) {
  return {
    showLogin: () => dispatch(showLogin()),
  };
}

const Footer = connect(mapStateToProps, mapDispatchToProps)(FooterComp);
export default Footer;

export function withFooterDrawer(footerProps = EMPTY_OBJECT) {
  return function(WrappedComponent) {
    class FooterDrawer extends React.PureComponent {
      render() {
        return (
          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: 'relative',
                zIndex: 1,
                pointerEvents: 'none',
              }}
            >
              <div
                style={{
                  backgroundColor: Style.Colors.white,
                  pointerEvents: 'auto',
                  overflow: 'hidden',
                }}
              >
                <WrappedComponent {...this.props} />
              </div>

              <div style={{ opacity: 0, pointerEvents: 'none' }}>
                <Footer {...footerProps} />
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: 0,
                backgroundColor: Style.Colors.black,
                paddingTop: '10rem',
              }}
            >
              <Footer {...footerProps} />
            </div>
          </div>
        );
      }
    }

    FooterDrawer.displayName = `FooterDrawer(${getDisplayName(WrappedComponent)})`;

    return FooterDrawer;
  };
}

function NavLink(props) {
  return (
    <H5>
      <Link {...props}>{props.children}</Link>
    </H5>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js